//프로젝트 인사이트
import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import { palette } from "../../../assets/styles/Palette";
import PopupWrap from "../../../assets/styles/Popup";
import { Button } from "../../../assets/styles/ButtonStyle";
import images from "../../../assets/styles/Images";
import MoleculeHeader from "../../Global/components/molecules/MoleculeHeader";
import {
  ContentsWrap,
  MainContent,
  TabContent5Item,
  TabContent5,
  PopupContent,
} from "../../../assets/styles/BusinessAnalysisStyle";
import {
  H1,
  Body3,
  Sub1,
  Caption1,
  Sub3,
  Body2,
  Sub2,
  Body1,
  H3,
} from "../../../assets/styles/Typography";
import {
  createCustomerOnServer,
  updateCustomerOnServer,
  getCustomerDetailOnServer,
  getCustomerListOnServer,
  getUserMemberType,
  getUserInfo,
  getEduBoardListOnServer,
  getEduBoardDetailOnServer,
  getEduBoardDeleteListOnServer,
  createEduBoardOnServer,
  updateEduBoardOnServer,
  getOrganizationUserListOnServer,
} from "../../../utils/indexedDB";

import OrganismCustomerItem from "../components/organisms/OrganismCustomerItem";
import class_one_img from "../../../assets/images/Background/class_one.png";
import class_all_img from "../../../assets/images/Background/whole_class.png";
import arrow_svg from "../../../assets/images/arrow.svg";
import {
  PROJECT_LIST,
  ACCESS_DASHBOARD,
  IS_LOGGED_IN,
  CREDIT_REQUEST_CUSTOM_PERSONA,
  CREDIT_REQUEST_BUSINESS_PERSONA,
  CREDIT_CUSTOM_THEORY,
  CREDIT_ADDITIONAL_QUESTION,
  CREDIT_INDEPTH_INTERVIEW,
  EVENT_TITLE,
  EVENT_STATE,
  TRIAL_STATE,
  CREDIT_CREATE_PERSONA_DEFAULT,
  CREDIT_CREATE_TOOL,
  CREDIT_CREATE_EXPERT,
  CREDIT_CREATE_MULTIMODAL,
  CREDIT_CREATE_INTERVIEW,
  CREDIT_CREATE_PROJECT,
  EDUCATION_STATE,
  PROJECT_EDUCATION_STATE,
  PROJECT_EDUCATION_CODE,
  CREDIT_CREATE_TOOL_LOW,
  CREDIT_CREATE_TOOL_HIGH,
  ADMIN_STATE,
  CUSTOMER_LIST,
  CUSTOMER_ID,
  CUSTOMER_NAME,
  SELECTED_CUSTOMER_TYPE,
  MEMBER_TYPE,
  CUSTOMER_DETAIL,
} from "../../AtomStates";
import { useDynamicViewport } from "../../../assets/DynamicViewport";

const PageCustomerManage = () => {
  useDynamicViewport("width=1280"); // 특정페이지에서만 pc화면처럼 보이기
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const gradeDropdownRef = useRef(null);
  const classDropdownRef = useRef(null);
  const teacherDropdownRef = useRef(null);
  const [, setCreditRequestCustomPersona] = useAtom(
    CREDIT_REQUEST_CUSTOM_PERSONA
  );
  const [, setCreditRequestBusinessPersona] = useAtom(
    CREDIT_REQUEST_BUSINESS_PERSONA
  );
  const [, setCreditCustomTheory] = useAtom(CREDIT_CUSTOM_THEORY);
  const [, setCreditAdditionalQuestion] = useAtom(CREDIT_ADDITIONAL_QUESTION);
  const [, setCreditIndepthInterview] = useAtom(CREDIT_INDEPTH_INTERVIEW);
  const [, setCreditCreatePersonaDefault] = useAtom(
    CREDIT_CREATE_PERSONA_DEFAULT
  );
  const [, setCreditCreateTool] = useAtom(CREDIT_CREATE_TOOL);
  const [, setCreditCreateExpert] = useAtom(CREDIT_CREATE_EXPERT);
  const [, setCreditCreateMultimodal] = useAtom(CREDIT_CREATE_MULTIMODAL);
  const [, setCreditCreateInterview] = useAtom(CREDIT_CREATE_INTERVIEW);
  const [, setCreditCreateProject] = useAtom(CREDIT_CREATE_PROJECT);
  const [, setCreditCreateToolLow] = useAtom(CREDIT_CREATE_TOOL_LOW);
  const [, setCreditCreateToolHigh] = useAtom(CREDIT_CREATE_TOOL_HIGH);
  const [, setEventTitle] = useAtom(EVENT_TITLE);
  const [, setEventState] = useAtom(EVENT_STATE);
  const [, setTrialState] = useAtom(TRIAL_STATE);
  const [, setAccessDashboard] = useAtom(ACCESS_DASHBOARD);
  const [isLoggedIn] = useAtom(IS_LOGGED_IN);
  const [adminState, setAdminState] = useAtom(ADMIN_STATE);
  const [isWarningPopupOpen, setIsWarningPopupOpen] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [deletedProjects, setDeletedProjects] = useState([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [isTrashModalOpen, setIsTrashModalOpen] = useState(false);
  const [showProjectList, setShowProjectList] = useState(false);
  const [showPreviewPopup, setShowPreviewPopup] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [contentTarget, setContentTarget] = useState("");
  const [autoDisplayFileAnalysis, setAutoDisplayFileAnalysis] = useState(null);
  const [showCustomerPopup, setShowCustomerPopup] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [address, setAddress] = useState("");
  const [companyInfo, setCompanyInfo] = useState("");
  const [customerList, setCustomerList] = useAtom(CUSTOMER_LIST);
  const [selectedCustomerType, setSelectedCustomerType] = useAtom(
    SELECTED_CUSTOMER_TYPE
  );
  const [organizationUserList, setOrganizationUserList] = useState([]);
  const [customerId, setCustomerId] = useAtom(CUSTOMER_ID);

  const [memberType, setMemberType] = useAtom(MEMBER_TYPE);
  const [customerDetail, setCustomerDetail] = useAtom(CUSTOMER_DETAIL);
  const [customerName, setCustomerName] = useAtom(CUSTOMER_NAME);

  const [isEdit, setIsEdit] = useState(false);
  const [userManagedBoards, setUserManagedBoards] = useState([]);
  const [currentUserEmail, setCurrentUserEmail] = useState("");
  const [currentUserName, setCurrentUserName] = useState("");
  const [initialCustomer, setInitialCustomer] = useState({
    companyName: "",
    address: "",
    companyInfo: "",
    boardType: "general",
  });

  const [eduCheckState, setEduCheckState] = useState(false);
  const [boardType, setBoardType] = useState("class"); // boardType 상태 추가, 기본값 "class"
  const [boardTypeDropdownOpen, setBoardTypeDropdownOpen] = useState(false); // 드롭다운 열림 상태

  // 새로운 상태들 추가
  const [selectedGrade, setSelectedGrade] = useState(""); // 학년 선택
  const [selectedClass, setSelectedClass] = useState(""); // 반 선택
  const [selectedTeacher, setSelectedTeacher] = useState(""); // 담임 선생님 선택
  const [selectedTeacherEmail, setSelectedTeacherEmail] = useState(""); // 담임 선생님 이메일 선택
  const [gradeDropdownOpen, setGradeDropdownOpen] = useState(false);
  const [classDropdownOpen, setClassDropdownOpen] = useState(false);
  const [teacherDropdownOpen, setTeacherDropdownOpen] = useState(false);

  const handleWarningClose = () => {
    setIsWarningPopupOpen(false);
    setShowWarning(false);
  };

  const getOrganizationUserList = async () => {
    const organizationUserList = await getOrganizationUserListOnServer();
    setOrganizationUserList(organizationUserList.data);
    setShowCustomerPopup(true);
  };

  // 사용자의 관리 게시판 정보를 가져오는 함수
  const fetchUserManagedBoards = async () => {
    try {
      const accessToken = sessionStorage.getItem("accessToken");
      const userInfo = await getUserInfo(accessToken);
      const userEmail = userInfo.email;
      const userName = userInfo.name;
      setCurrentUserEmail(userEmail);
      setCurrentUserName(userName);

      // 교육 게시판 목록 가져오기
      const eduBoardList = await getEduBoardListOnServer(999, 1, isLoggedIn);

      if (eduBoardList && eduBoardList.data) {
        // 현재 사용자가 관리하는 게시판들 필터링
        const managedBoards = eduBoardList.data.filter(
          (board) => board.manager === userEmail
        );
        setUserManagedBoards(managedBoards);
        console.log("User managed boards:", managedBoards);
      }
    } catch (error) {
      console.error("Failed to fetch user managed boards:", error);
    }
  };

  // 학년과 반 선택 시 companyName 자동 업데이트
  useEffect(() => {
    if (
      selectedGrade &&
      selectedClass &&
      (memberType === 32 || Number(selectedCustomerType) === 3)
    ) {
      const combinedName = `${selectedGrade} ${selectedClass}`;
      setCompanyName(combinedName);
    }
  }, [selectedGrade, selectedClass, memberType, selectedCustomerType]);

  // 드롭다운 외부 클릭 시 닫기
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        gradeDropdownRef.current &&
        !gradeDropdownRef.current.contains(event.target) &&
        classDropdownRef.current &&
        !classDropdownRef.current.contains(event.target) &&
        teacherDropdownRef.current &&
        !teacherDropdownRef.current.contains(event.target)
      ) {
        setBoardTypeDropdownOpen(false);
        setGradeDropdownOpen(false);
        setClassDropdownOpen(false);
        setTeacherDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    sessionStorage.removeItem("customerId");

    const checkMemberType = async () => {
      const accessToken = sessionStorage.getItem("accessToken");
      const userMemberType = await getUserMemberType(accessToken);
      if (userMemberType.member_type === 11) {
        navigate("/DashBoard");
      } else if (userMemberType.member_type === 21) {
        navigate("/ApiDashBoard");
      }
    };

    checkMemberType();
  }, []);

  const handleStart = () => {
    setIsWarningPopupOpen(false);
    navigate("/ProjectCreate");
  };

  useEffect(() => {
    // 새로고침 감지 함수
    const detectRefresh = () => {
      //  현재 URL 확인
      const currentUrl = window.location.href;

      // 현재 URL 저장
      sessionStorage.setItem("lastUrl", currentUrl);
      const lastUrl = sessionStorage.getItem("lastUrl");
    };
    // 함수 실행
    detectRefresh();

    // 컴포넌트 마운트 시 한 번만 실행
  }, [navigate]);

  useEffect(() => {
    // setAccessDashboard(false);

    const loadCustomerList = async () => {
      // const customerId = await createCustomerOnServer(isLoggedIn);
      const accessToken = sessionStorage.getItem("accessToken");
      const userMemberType = await getUserMemberType(accessToken);

      setMemberType(userMemberType.member_type);

      // memberType이 31이면 사용자의 관리 게시판 정보를 가져옴
      if (userMemberType.member_type === 31) {
        await fetchUserManagedBoards();
        return; // memberType 31은 여기서 종료
      }

      let customerType;
      console.log("userMemberType.member_type:", userMemberType.member_type);
      if (userMemberType.member_type === 32) {
        customerType = 3;
      } else if (userMemberType.member_type === 22) {
        customerType = 2;
      } else if (
        Number.isFinite(Number(userMemberType.member_type)) &&
        String(Number(userMemberType.member_type) / 10).includes("2")
      ) {
        // (member_type / 10)의 문자열 표현에 '2'가 포함되어 있으면 참
        // 예: 21 -> 2.1 -> '2.1' includes '2' -> true
        customerType = 2;
      } else if (userMemberType.member_type === 12) {
        customerType = 1;
      } else if (userMemberType.member_type === 99) {
        if (selectedCustomerType === 0) {
          navigate("/Admin");
        } else {
          customerType = selectedCustomerType;
        }
      }

      try {
        let customerListResponse;

        if (customerType === 3) {
          customerListResponse = await getEduBoardListOnServer(
            999,
            1,
            isLoggedIn
          );
        } else {
          customerListResponse = await getCustomerListOnServer(
            customerType,
            999,
            1,
            isLoggedIn
          );
        }
        if (customerListResponse) {
          setCustomerList(customerListResponse.data);
        }
        console.log(customerListResponse);
      } catch (error) {
        console.error("Failed to load customer list:", error);
      }
    };
    loadCustomerList();
  }, [refreshTrigger, isLoggedIn]);

  const handleCustomerSubmit = async (editId) => {
    try {
      console.log(editId);
      setShowCustomerPopup(false);
      const accessToken = sessionStorage.getItem("accessToken");
      const userMemberType = await getUserMemberType(accessToken);
      let customerType;
      if (userMemberType.member_type === 22) {
        customerType = 2;
      } else if (
        Number.isFinite(Number(userMemberType.member_type)) &&
        String(Number(userMemberType.member_type) / 10).includes("2")
      ) {
        customerType = 2;
      } else if (userMemberType.member_type === 12) {
        customerType = 1;
      } else if (userMemberType.member_type === 32) {
        customerType = 3;
      } else if (userMemberType.member_type === 99) {
        customerType = selectedCustomerType;
      }
      const data = {
        companyName: companyName,
        address: customerType === 3 ? "" : address,
        companyInfo: companyInfo,
        customerType: customerType,
      };

      // customerType이 3인 경우 boardType과 담임선생님 이메일 추가
      if (customerType === 3) {
        data.boardType = boardType;
        data.manager = selectedTeacherEmail;
      }

      if (isEdit) {
        if (customerType === 3) {
          await updateEduBoardOnServer(editId, data);
        } else {
          await updateCustomerOnServer(editId, data);
        }
      } else {
        if (customerType === 3) {
          const customerId = await createEduBoardOnServer(isLoggedIn);
          await updateEduBoardOnServer(customerId, data);
        } else {
          const customerId = await createCustomerOnServer(isLoggedIn);
          await updateCustomerOnServer(customerId, data);
        }
      }
      // 저장 후 리스트 다시 불러오기
      let customerListResponse;
      if (customerType === 3) {
        customerListResponse = await getEduBoardListOnServer(
          999,
          1,
          isLoggedIn
        );
      } else {
        customerListResponse = await getCustomerListOnServer(
          customerType,
          999,
          1,
          isLoggedIn
        );
      }
      if (customerListResponse) {
        setCustomerList(customerListResponse.data);
      }
    } catch (error) {
      console.error(
        `${
          memberType === 32 || Number(selectedCustomerType) === 3
            ? "교내 게시판"
            : "고객사"
        } 등록에 실패했습니다:`,
        error
      );
    } finally {
      setCompanyName("");
      setAddress("");
      setCompanyInfo("");
      setBoardType("class"); // boardType 초기화
      setSelectedGrade(""); // 학년 초기화
      setSelectedClass(""); // 반 초기화
      setSelectedTeacher(""); // 담임 선생님 초기화
      setSelectedTeacherEmail(""); // 담임 선생님 이메일 초기화
      setInitialCustomer({
        companyName: "",
        address: "",
        companyInfo: "",
        boardType: "class",
      });
      setCustomerId("");
      setCustomerDetail(null);
      setIsEdit(false);
      setBoardTypeDropdownOpen(false);
      setGradeDropdownOpen(false);
      setClassDropdownOpen(false);
      setTeacherDropdownOpen(false);
    }
  };

  return (
    <>
      <ContentsWrap>
        <MoleculeHeader />
        <MainContent Wide1030>
          <ProjectWrap>
            <HeaderWrap>
              {memberType !== 31 && (
                <div
                  style={{ display: "flex", flexDirection: "row", gap: "10px" }}
                >
                  {/* {educationState && (
                  <LogoCard>
                    <img src={images.dcbLogo} alt="logo" />
                  </LogoCard>
                )} */}
                  <div>
                    <H1 color="gray800" align="left">
                      {memberType === 32 || Number(selectedCustomerType) === 3
                        ? "교내 게시판 관리"
                        : "고객사 관리"}
                    </H1>
                    <div style={{ height: "10px" }}></div>
                    <Body3 color="gray700" align="left">
                      등록된{" "}
                      {memberType === 32 || Number(selectedCustomerType) === 3
                        ? "교내 게시판"
                        : "고객사"}
                      의 디스플레이와 콘텐츠를 손쉽게 관리해보세요
                    </Body3>
                  </div>
                </div>
              )}
              {memberType !== 31 && (
                <div
                  style={{ display: "flex", flexDirection: "row", gap: "10px" }}
                >
                  <Button
                    Large
                    Primary
                    Fill
                    onClick={() => {
                      if (
                        memberType === 32 ||
                        Number(selectedCustomerType) === 3
                      ) {
                        getOrganizationUserList();
                      } else {
                        setShowCustomerPopup(true);
                      }
                    }}
                  >
                    <Sub2 color="white">
                      {memberType === 32 || Number(selectedCustomerType) === 3
                        ? "신규 교내 게시판 등록"
                        : "신규 고객사 등록"}
                    </Sub2>
                  </Button>
                  {/* <Button Outline radius="4px" onClick={() => setIsTrashModalOpen(true)}>
                    <img src={images.Trash} alt="" />
                    <Caption1 color="gray700">임시 삭제함</Caption1>
                  </Button> */}
                </div>
              )}
            </HeaderWrap>

            <ProjectListWrap>
              {memberType === 31 ? (
                // memberType 31 - 카드 UI
                <EducationSection>
                  <EducationHeader>
                    <H1 color="gray800" align="center">
                      {currentUserName} 선생님,
                    </H1>
                    <H1
                      color="gray800"
                      align="center"
                      style={{ marginTop: "4px" }}
                    >
                      이용할 게시판을 선택해주세요
                    </H1>
                    <Body3
                      color="gray700"
                      align="center"
                      style={{ marginTop: "16px" }}
                    >
                      선택하신 게시판의 대시보드로 이동합니다.
                    </Body3>
                  </EducationHeader>
                  <CardContainer>
                    {userManagedBoards.map((board, index) => {
                      // 게시판 이름에 따라 이미지와 설명 결정
                      const isGradeBoard =
                        board.companyName &&
                        board.companyName.includes("학년 주임");
                      const cardImage = isGradeBoard
                        ? class_all_img
                        : class_one_img;
                      const cardTitle = isGradeBoard
                        ? board.companyName.replace("학년 주임", "학년 전체")
                        : board.companyName;
                      const cardDesc = isGradeBoard
                        ? "학년 전체 대상 공지와 일정을 콘텐츠로 생성하고 원하는 시간에 편성하세요."
                        : "우리 반 소식과 일정을 콘텐츠로 생성하고 원하는 시간에 편성하세요.";

                      return (
                        <Card key={board._id || index}>
                          <CardImg>
                            <img
                              src={cardImage}
                              alt={cardTitle}
                              style={{
                                width: "320px",
                                height: "157px",
                                objectFit: "contain",
                              }}
                            />
                          </CardImg>
                          <EducationCardContent>
                            <CardTitle>{cardTitle}</CardTitle>
                            <CardArrangement>
                              <CardDesc>{cardDesc}</CardDesc>
                              <ButtonArrow
                                onClick={() => {
                                  // 해당 게시판의 정보를 세션에 저장하고 대시보드로 이동
                                  sessionStorage.setItem(
                                    "customerId",
                                    board._id
                                  );
                                  navigate("/EducationDashBoard");
                                }}
                              >
                                <img src={arrow_svg} alt="arrow" />
                                <span>이동</span>
                              </ButtonArrow>
                            </CardArrangement>
                          </EducationCardContent>
                        </Card>
                      );
                    })}
                  </CardContainer>
                </EducationSection>
              ) : memberType === 32 || Number(selectedCustomerType) === 3 ? (
                // 교내 게시판 관리 - boardType별 그룹화
                <>
                  {/* 학급 및 학년 전용 섹션 */}
                  <BoardSection>
                    <SectionTitle>
                      <H3 color="gray800" align="left">
                        학급 및 학년 전용 게시판
                      </H3>
                    </SectionTitle>
                    <ProjectList>
                      {customerList
                        .filter(
                          (customer) =>
                            customer.boardType === "class" ||
                            customer.boardType === "general" ||
                            !customer.boardType
                        )
                        .map((customer) => (
                          <OrganismCustomerItem
                            key={customer._id}
                            setShowCustomerPopup={setShowCustomerPopup}
                            setCompanyName={setCompanyName}
                            setAddress={setAddress}
                            setCompanyInfo={setCompanyInfo}
                            setBoardType={setBoardType}
                            setInitialCustomer={setInitialCustomer}
                            setIsEdit={setIsEdit}
                            customer={customer}
                            selectedCustomerId={setCustomerId}
                            getOrganizationUserList={getOrganizationUserList}
                          />
                        ))}
                      <OrganismCustomerItem
                        isNoData={true}
                        setShowCustomerPopup={setShowCustomerPopup}
                        getOrganizationUserList={getOrganizationUserList}
                        onClick={() => {
                          setCompanyName("");
                          setAddress("");
                          setCompanyInfo("");
                          setBoardType("class");
                          setSelectedGrade("");
                          setSelectedClass("");
                          setSelectedTeacher("");
                          setSelectedTeacherEmail("");
                          setCustomerDetail(null);
                          setIsEdit(false);
                          setShowCustomerPopup(true);
                          setBoardTypeDropdownOpen(false);
                          setGradeDropdownOpen(false);
                          setClassDropdownOpen(false);
                          setTeacherDropdownOpen(false);
                        }}
                      />
                    </ProjectList>
                  </BoardSection>

                  {/* 급식 섹션 */}
                  <BoardSection>
                    <SectionTitle>
                      <H3 color="gray800" align="left">
                        급식 전용 게시판
                      </H3>
                    </SectionTitle>
                    <ProjectList>
                      {customerList
                        .filter((customer) => customer.boardType === "meal")
                        .map((customer) => (
                          <OrganismCustomerItem
                            key={customer._id}
                            setShowCustomerPopup={setShowCustomerPopup}
                            setCompanyName={setCompanyName}
                            setAddress={setAddress}
                            setCompanyInfo={setCompanyInfo}
                            setBoardType={setBoardType}
                            setInitialCustomer={setInitialCustomer}
                            setIsEdit={setIsEdit}
                            customer={customer}
                            selectedCustomerId={setCustomerId}
                            getOrganizationUserList={getOrganizationUserList}
                          />
                        ))}
                      <OrganismCustomerItem
                        isNoData={true}
                        setShowCustomerPopup={setShowCustomerPopup}
                        setBoardType={setBoardType}
                        boardType="meal"
                        getOrganizationUserList={getOrganizationUserList}
                        onClick={() => {
                          setCompanyName("");
                          setAddress("");
                          setCompanyInfo("");
                          setBoardType("meal");
                          setSelectedGrade("");
                          setSelectedClass("");
                          setSelectedTeacher("");
                          setSelectedTeacherEmail("");
                          setCustomerDetail(null);
                          setIsEdit(false);
                          setShowCustomerPopup(true);
                          setBoardTypeDropdownOpen(false);
                          setGradeDropdownOpen(false);
                          setClassDropdownOpen(false);
                          setTeacherDropdownOpen(false);
                        }}
                      />
                    </ProjectList>
                  </BoardSection>
                </>
              ) : (
                // 고객사 관리 - 기존 구조 유지
                <ProjectList>
                  {customerList.map((customer) => (
                    <OrganismCustomerItem
                      key={customer._id}
                      setShowCustomerPopup={setShowCustomerPopup}
                      setCompanyName={setCompanyName}
                      setAddress={setAddress}
                      setCompanyInfo={setCompanyInfo}
                      setBoardType={setBoardType}
                      setInitialCustomer={setInitialCustomer}
                      setIsEdit={setIsEdit}
                      customer={customer}
                      selectedCustomerId={setCustomerId}
                      getOrganizationUserList={getOrganizationUserList}
                    />
                  ))}
                  <OrganismCustomerItem
                    isNoData={true}
                    setShowCustomerPopup={setShowCustomerPopup}
                    setBoardType={setBoardType}
                    boardType="general"
                    getOrganizationUserList={getOrganizationUserList}
                    onClick={() => {
                      setCompanyName("");
                      setAddress("");
                      setCompanyInfo("");
                      setBoardType("class");
                      setSelectedGrade("");
                      setSelectedClass("");
                      setSelectedTeacher("");
                      setSelectedTeacherEmail("");
                      setCustomerDetail(null);
                      setIsEdit(false);
                      setShowCustomerPopup(true);
                      setBoardTypeDropdownOpen(false);
                      setGradeDropdownOpen(false);
                      setClassDropdownOpen(false);
                      setTeacherDropdownOpen(false);
                    }}
                  />
                </ProjectList>
              )}
            </ProjectListWrap>
          </ProjectWrap>
        </MainContent>
      </ContentsWrap>
      {/* {showWarning && (
        <PopupWrap
          Warning
          title="정말 삭제하시겠습니까?"
          message="삭제된 프로젝트는 임시 삭제함에서 복구 가능합니다."
          buttonType="Outline"
          closeText="취소"
          confirmText="확인"
          isModal={false}
          onCancel={handleWarningClose}
          onConfirm={handleWarningContinue}
        />
      )} */}

      {showCustomerPopup && (
        <PopupWrap
          TitleFlex
          title={
            isEdit
              ? memberType === 32 || Number(selectedCustomerType) === 3
                ? "교내 게시판 정보"
                : "고객사 정보"
              : memberType === 32 || Number(selectedCustomerType) === 3
              ? "교내 게시판 등록하기"
              : "고객사 등록하기"
          }
          buttonType="Fill"
          confirmText={isEdit ? "편집 내용 저장" : "게시판 등록하기"}
          isModal={true}
          onCancel={() => {
            setShowCustomerPopup(false);
            setIsEdit(false);
            setCompanyName("");
            setAddress("");
            setCompanyInfo("");
            setBoardType("class");
            setSelectedGrade("");
            setSelectedClass("");
            setSelectedTeacher("");
            setSelectedTeacherEmail("");
            setCustomerDetail(null);
            setBoardTypeDropdownOpen(false);
            setGradeDropdownOpen(false);
            setClassDropdownOpen(false);
            setTeacherDropdownOpen(false);
          }}
          onConfirm={
            isEdit
              ? () => handleCustomerSubmit(customerId)
              : handleCustomerSubmit
          }
          showTabs={true}
          // tabs={["기본정보", "OCEAN 정보", "요청사항확인"]}
          eventState={false}
          creditRequestCustomPersona={100}
          isFormValid={(() => {
            // 교내 게시판인지 확인
            const isEducationBoard =
              memberType === 32 || Number(selectedCustomerType) === 3;

            if (isEducationBoard) {
              // 교내 게시판의 경우
              const baseValid = !!boardType; // 게시판 유형 필수

              if (boardType === "class") {
                // 학급 및 학년 전용 게시판
                return (
                  baseValid &&
                  !!selectedGrade &&
                  !!selectedClass &&
                  !!selectedTeacher
                );
              } else if (boardType === "meal") {
                // 급식 전용 게시판
                return baseValid && !!companyName;
              }

              return baseValid;
            } else {
              // 일반 고객사의 경우
              return !!companyName && !!address;
            }
          })()}
          body={
            <div>
              <>
                {(memberType === 32 || Number(selectedCustomerType) === 3) && (
                  <div className="column">
                    <Body2 color="gray700" align="left">
                      게시판 유형
                      <span style={{ color: "red" }}>*</span>
                    </Body2>
                    <PopupContent>
                      {isEdit ? (
                        <InputBox>
                          <InputText
                            readOnly
                            value={
                              boardType === "class"
                                ? "학급 및 학년 전용 게시판"
                                : "급식 전용 게시판"
                            }
                          />
                        </InputBox>
                      ) : (
                        <DropdownContainer ref={dropdownRef}>
                          <DropdownHeader
                            onClick={() =>
                              setBoardTypeDropdownOpen(!boardTypeDropdownOpen)
                            }
                          >
                            <DropdownText>
                              {boardType === "class"
                                ? "학급 및 학년 전용 게시판"
                                : "급식 전용 게시판"}
                            </DropdownText>
                            <images.ChevronDown
                              width="24px"
                              height="24px"
                              color={palette.gray500}
                              style={{
                                transform: boardTypeDropdownOpen
                                  ? "rotate(180deg)"
                                  : "rotate(0deg)",
                                transition: "transform 0.3s ease",
                              }}
                            />
                          </DropdownHeader>
                          {boardTypeDropdownOpen && (
                            <DropdownList>
                              <DropdownItem
                                onClick={() => {
                                  setBoardType("class");
                                  setBoardTypeDropdownOpen(false);
                                }}
                              >
                                <RadioButton
                                  type="radio"
                                  id="class"
                                  name="boardType"
                                  value="class"
                                  checked={boardType === "class"}
                                  onChange={(e) => {
                                    setBoardType(e.target.value);
                                    setBoardTypeDropdownOpen(false);
                                  }}
                                />
                                <RadioButtonLabel htmlFor="class">
                                  학급 및 학년 전용 게시판
                                </RadioButtonLabel>
                              </DropdownItem>
                              <DropdownItem
                                onClick={() => {
                                  setBoardType("meal");
                                  setBoardTypeDropdownOpen(false);
                                }}
                              >
                                <RadioButton
                                  type="radio"
                                  id="meal"
                                  name="boardType"
                                  value="meal"
                                  checked={boardType === "meal"}
                                  onChange={(e) => {
                                    setBoardType(e.target.value);
                                    setBoardTypeDropdownOpen(false);
                                  }}
                                />
                                <RadioButtonLabel htmlFor="meal">
                                  급식 전용 게시판
                                </RadioButtonLabel>
                              </DropdownItem>
                            </DropdownList>
                          )}
                        </DropdownContainer>
                      )}
                    </PopupContent>
                  </div>
                )}

                {(memberType === 32 || Number(selectedCustomerType) === 3) && (
                  <div className="column">
                    <Body2 color="gray700" align="left">
                      게시판 이름
                      <span style={{ color: "red" }}>*</span>
                    </Body2>
                    <PopupGroup>
                      <PopupContent>
                        <DropdownContainer2 ref={gradeDropdownRef}>
                          <DropdownHeader
                            onClick={() => {
                              if (gradeDropdownOpen) {
                                setGradeDropdownOpen(false);
                              } else {
                                setGradeDropdownOpen(true);
                                setClassDropdownOpen(false);
                                setTeacherDropdownOpen(false);
                              }
                            }}
                          >
                            <GradeDropdownText hasValue={!!selectedGrade}>
                              {selectedGrade || "학년 선택"}
                            </GradeDropdownText>
                            <images.ChevronDown
                              width="24px"
                              height="24px"
                              color={palette.gray500}
                              style={{
                                transform: gradeDropdownOpen
                                  ? "rotate(180deg)"
                                  : "rotate(0deg)",
                                transition: "transform 0.3s ease",
                              }}
                            />
                          </DropdownHeader>
                          {gradeDropdownOpen && (
                            <DropdownList>
                              {["1학년", "2학년", "3학년"].map((grade) => (
                                <DropdownItem
                                  key={grade}
                                  onClick={() => {
                                    setSelectedGrade(grade);
                                    setSelectedClass(""); // 학년 변경시 반 초기화
                                    setGradeDropdownOpen(false);
                                  }}
                                >
                                  <RadioButton
                                    type="radio"
                                    id={grade}
                                    name="grade"
                                    value={grade}
                                    checked={selectedGrade === grade}
                                    onChange={(e) => {
                                      setSelectedGrade(e.target.value);
                                      setSelectedClass(""); // 학년 변경시 반 초기화
                                      setGradeDropdownOpen(false);
                                    }}
                                  />
                                  <RadioButtonLabel htmlFor={grade}>
                                    {grade}
                                  </RadioButtonLabel>
                                </DropdownItem>
                              ))}
                            </DropdownList>
                          )}
                        </DropdownContainer2>
                      </PopupContent>
                      <PopupContent>
                        <DropdownContainer3 ref={classDropdownRef}>
                          <DropdownHeader
                            onClick={() => {
                              if (classDropdownOpen) {
                                setClassDropdownOpen(false);
                              } else {
                                setClassDropdownOpen(true);
                                setGradeDropdownOpen(false);
                                setTeacherDropdownOpen(false);
                              }
                            }}
                          >
                            <ClassDropdownText hasValue={!!selectedClass}>
                              {selectedClass || "반 선택"}
                            </ClassDropdownText>
                            <images.ChevronDown
                              width="24px"
                              height="24px"
                              color={palette.gray500}
                              style={{
                                transform: classDropdownOpen
                                  ? "rotate(180deg)"
                                  : "rotate(0deg)",
                                transition: "transform 0.3s ease",
                              }}
                            />
                          </DropdownHeader>
                          {classDropdownOpen && (
                            <DropdownList>
                              <DropdownItem
                                onClick={() => {
                                  setSelectedClass("학년 주임");
                                  setClassDropdownOpen(false);
                                }}
                              >
                                <RadioButton
                                  type="radio"
                                  id="학년 주임"
                                  name="class"
                                  value="학년 주임"
                                  checked={selectedClass === "학년 주임"}
                                  onChange={(e) => {
                                    setSelectedClass(e.target.value);
                                    setClassDropdownOpen(false);
                                  }}
                                />
                                <RadioButtonLabel htmlFor="학년 주임">
                                  학년 주임
                                </RadioButtonLabel>
                              </DropdownItem>
                              {Array.from(
                                { length: selectedGrade === "3학년" ? 12 : 11 },
                                (_, i) => i + 1
                              ).map((classNum) => (
                                <DropdownItem
                                  key={classNum}
                                  onClick={() => {
                                    setSelectedClass(`${classNum}반`);
                                    setClassDropdownOpen(false);
                                  }}
                                >
                                  <RadioButton
                                    type="radio"
                                    id={`${classNum}반`}
                                    name="class"
                                    value={`${classNum}반`}
                                    checked={selectedClass === `${classNum}반`}
                                    onChange={(e) => {
                                      setSelectedClass(e.target.value);
                                      setClassDropdownOpen(false);
                                    }}
                                  />
                                  <RadioButtonLabel htmlFor={`${classNum}반`}>
                                    {classNum}반
                                  </RadioButtonLabel>
                                </DropdownItem>
                              ))}
                            </DropdownList>
                          )}
                        </DropdownContainer3>
                      </PopupContent>
                    </PopupGroup>
                  </div>
                )}
                <div className="column">
                  <Body2 color="gray700" align="left">
                    {memberType === 32 || Number(selectedCustomerType) === 3
                      ? "담임 선생님"
                      : "고객사 명"}
                    <span style={{ color: "red" }}>*</span>
                  </Body2>
                  <PopupContent>
                    {memberType === 32 || Number(selectedCustomerType) === 3 ? (
                      <DropdownContainer ref={teacherDropdownRef}>
                        <DropdownHeader
                          onClick={() => {
                            if (teacherDropdownOpen) {
                              setTeacherDropdownOpen(false);
                            } else {
                              setTeacherDropdownOpen(true);
                              setGradeDropdownOpen(false);
                              setClassDropdownOpen(false);
                            }
                          }}
                        >
                          <TeacherDropdownText hasValue={!!selectedTeacher}>
                            {selectedTeacher || "선택하세요"}
                          </TeacherDropdownText>
                          <images.ChevronDown
                            width="24px"
                            height="24px"
                            color={palette.gray500}
                            style={{
                              transform: teacherDropdownOpen
                                ? "rotate(180deg)"
                                : "rotate(0deg)",
                              transition: "transform 0.3s ease",
                            }}
                          />
                        </DropdownHeader>
                        {teacherDropdownOpen && (
                          <DropdownList>
                            {organizationUserList.map((teacher, index) => (
                              <DropdownItem
                                key={teacher.email || index}
                                onClick={() => {
                                  setSelectedTeacher(teacher.name);
                                  setSelectedTeacherEmail(teacher.email);
                                  setTeacherDropdownOpen(false);
                                }}
                              >
                                <RadioButton
                                  type="radio"
                                  id={`teacher-${teacher.email || index}`}
                                  name="teacher"
                                  value={teacher.name}
                                  checked={selectedTeacher === teacher.name}
                                  onChange={(e) => {
                                    setSelectedTeacher(e.target.value);
                                    setSelectedTeacherEmail(teacher.email);
                                    setTeacherDropdownOpen(false);
                                  }}
                                />
                                <RadioButtonLabel
                                  htmlFor={`teacher-${teacher.email || index}`}
                                >
                                  {teacher.name}
                                </RadioButtonLabel>
                              </DropdownItem>
                            ))}
                          </DropdownList>
                        )}
                      </DropdownContainer>
                    ) : (
                      <InputBox>
                        <InputText
                          placeholder="입력해주세요"
                          value={companyName}
                          onChange={(e) => setCompanyName(e.target.value)}
                        />
                      </InputBox>
                    )}
                  </PopupContent>
                </div>
                {!(memberType === 32 || Number(selectedCustomerType) === 3) && (
                  <div className="column">
                    <Body2 color="gray700" align="left">
                      주소지
                      <span style={{ color: "red" }}>*</span>
                    </Body2>
                    <PopupContent>
                      <InputBox>
                        <InputText
                          placeholder="입력해주세요"
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                        />
                      </InputBox>
                    </PopupContent>
                  </div>
                )}
                <div className="column">
                  <Body2 color="gray700" align="left">
                    {memberType === 32 || Number(selectedCustomerType) === 3
                      ? "게시판 관련 정보"
                      : "고객사 관련 정보"}
                  </Body2>
                  <PopupContent>
                    <InputBox2>
                      <InputTextArea
                        value={companyInfo}
                        onChange={(e) => setCompanyInfo(e.target.value)}
                        placeholder="입력해주세요"
                        rows={4}
                      />
                    </InputBox2>
                  </PopupContent>
                </div>
              </>
            </div>
          }
        />
      )}
    </>
  );
};

export default PageCustomerManage;

const ProjectWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 54px;
  margin: 50px auto;
`;

const HeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

const ProjectListWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const ProjectList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

const BoardSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 40px;
`;

const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

export const BgBoxItem = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 4px;
  width: 100%;
  padding: ${(props) => (props.NoOutline ? "12px" : "8px 12px")};
  border-radius: 10px;
  border: ${(props) =>
    props.NoOutline ? "0" : `1px solid ${palette.outlineGray}`};
  background: ${(props) => (props.white ? palette.white : palette.chatGray)};
`;

const InterviewModeSelection = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
  justify-content: center;
  margin-bottom: 30px;

  .button-container {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 20px;
  }
`;

const InterviewModeCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  padding-top: 30px;
  border-radius: 10px;
  border: 1px solid
    ${(props) => (props.isActive ? palette.primary : palette.outlineGray)};
  cursor: pointer;
  background-color: ${(props) =>
    props.isActive ? "rgba(34, 111, 255, 0.05)" : "white"};
  position: relative;
  width: calc(50% - 10px);

  &:hover {
    border-color: ${palette.primary};
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
    transform: translateY(-2px);
  }
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;

  img {
    width: 48px;
    height: 48px;
    margin-bottom: 4px;
  }

  div {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
  }
`;

const CheckboxWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  margin-left: 0;
`;

const CustomizationWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  cursor: pointer;

  > div {
    width: 100%;
  }

  button span {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid ${palette.gray700};

    &::before,
    &::after {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 8px;
      height: 1px;
      background: ${palette.gray700};
      content: "";
    }

    &::after {
      transform: translate(-50%, -50%) rotate(90deg);
    }
  }
`;

export const CheckCircle = styled.input`
  appearance: none;
  display: block !important;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
  background-image: ${(props) =>
    props.checked
      ? `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Ccircle cx='12' cy='12' r='12' fill='%23226FFF'/%3E%3Cpath d='M6.76562 12.4155L9.9908 15.6365L17.2338 8.36426' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`
      : `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Ccircle cx='12' cy='12' r='11.5' stroke='%23E0E4EB'/%3E%3C/svg%3E")`};
  transition: background-image 0.3s ease-in-out;

  + label {
    cursor: pointer;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;

    + label {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
`;

const LogoCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 5px;
  border: 1px solid ${palette.outlineGray};
  background: ${palette.white};
`;

const InputBox = styled.div`
  height: 56px;
  padding: 0 16px;
  background: rgba(179, 183, 186, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  width: 100%;
`;

const InputBox2 = styled.div`
  height: 150px;
  padding: 0 16px;
  background: rgba(179, 183, 186, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: flex-start;
  width: 100%;
`;

const InputText = styled.input`
  width: 100%;
  border: none;
  background: transparent;
  color: ${palette.gray800};
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 28.5px;
  outline: none;
  &::placeholder {
    color: ${palette.gray300};
  }
`;

const InputText2 = styled.input`
  width: 100%;
  border: none;
  background: transparent;
  color: ${palette.gray500};
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 28.5px;
  outline: none;
  &::placeholder {
    color: ${palette.gray300};
  }
`;

const InputTextArea = styled.textarea`
  width: 100%;
  border: none;
  background: transparent;
  color: ${palette.gray800};
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 28.5px;
  outline: none;
  padding-top: 16px;
  resize: none;
  &::placeholder {
    color: ${palette.gray300};
  }
`;

const PopupGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

const DropdownContainer = styled.div`
  position: relative;
  width: 100%;
`;

const DropdownContainer2 = styled.div`
  position: relative;
  width: 198px;
`;

const DropdownContainer3 = styled.div`
  position: relative;
  width: 295px;
`;

const DropdownHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 56px;
  padding: 0 16px;
  background: rgba(179, 183, 186, 0.1);
  border-radius: 8px;
  cursor: pointer;
`;

const DropdownText = styled.span`
  color: ${palette.gray800};
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 28.5px;
`;

const DropdownList = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  background-color: ${palette.white};
  border: 1px solid ${palette.outlineGray};
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 10;
  padding: 8px 0;
`;

const DropdownItem = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  gap: 10px;
  transition: background-color 0.2s ease-in-out;
  border-radius: 6px;
  margin: 0 4px;

  &:hover {
    background-color: ${palette.backgroundGray};
  }

  &:hover input[type="radio"]:not(:checked) {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'%3E%3Ccircle cx='10' cy='10' r='9.5' stroke='%23226FFF'/%3E%3C/svg%3E") !important;
  }

  &:hover label {
    color: ${palette.primary};
  }
`;

const RadioButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  width: 100%;
`;

const RadioButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const RadioButton = styled.input`
  appearance: none;
  display: block !important;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  cursor: pointer;
  background-image: ${(props) =>
    props.checked
      ? `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'%3E%3Ccircle cx='10' cy='10' r='10' fill='%23226FFF'/%3E%3Ccircle cx='10' cy='10' r='5' fill='white'/%3E%3C/svg%3E")`
      : `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'%3E%3Ccircle cx='10' cy='10' r='9.5' stroke='%23E0E4EB'/%3E%3C/svg%3E")`};
  transition: background-image 0.3s ease-in-out;

  &:hover:not(:checked) {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'%3E%3Ccircle cx='10' cy='10' r='9.5' stroke='%23226FFF'/%3E%3C/svg%3E");
  }

  + label {
    cursor: pointer;
    transition: color 0.3s ease-in-out;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;

    + label {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
`;

const RadioButtonLabel = styled.label`
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 28.5px;
  color: ${palette.gray800};
  cursor: pointer;
  transition: color 0.2s ease-in-out;
  user-select: none;
`;

const GradeDropdownText = styled.span`
  color: ${(props) => (props.hasValue ? "#323232" : palette.gray300)};
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 28.5px;
`;

const ClassDropdownText = styled.span`
  color: ${(props) => (props.hasValue ? "#323232" : palette.gray300)};
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 28.5px;
`;

const TeacherDropdownText = styled.span`
  color: ${(props) => (props.hasValue ? "#323232" : palette.gray300)};
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 28.5px;
`;

const EducationSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 80px 0;
`;

const EducationHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 60px;
  text-align: center;
`;

const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  max-width: 680px;
`;

const Card = styled.div`
  width: 320px;
  min-height: 320px;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.07);
  padding: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
  cursor: pointer;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.07), 0 0 0 1.5px #256ef4;
  }
`;

const CardImg = styled.div`
  width: 100%;
  height: 157px;
  object-fit: contain;
`;

const CardArrangement = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
  height: 100%;
`;

const EducationCardContent = styled.div`
  width: 100%;
  height: 163px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;

const CardTitle = styled(Body3)`
  font-size: 20px;
  font-weight: 700;
  color: #323232;
  margin-bottom: 8px;
  text-align: center;
`;

const CardDesc = styled(Body2)`
  color: #464c53;
  font-size: 15px;
  text-align: center;
  margin-bottom: 8px;
  flex-grow: 1;
`;

const ButtonArrow = styled.button`
  background: transparent;
  border: 1px solid #256ef4;
  border-radius: 50%;
  box-sizing: border-box; /* border 두께까지 포함해서 계산 */
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  width: 34px;
  height: 34px;
  min-width: 34px;
  min-height: 34px;
  overflow: hidden;

  transition: width 0.2s, padding 0.2s, box-shadow 0.2s, border-radius 0.2s,
    opacity 0.2s;

  svg,
  img {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    transition: transform 0.2s;
  }

  span {
    display: none;
    margin-left: 6px;
    font-size: 16px;
    font-family: Pretendard, sans-serif;
    font-weight: 700;
    color: #256ef4;
    white-space: nowrap;
    transition: opacity 0.2s;
  }

  &:hover {
    width: auto;
    padding: 5px 15px;
    border-radius: 17px;

    box-shadow: 0 0 0 1px #256ef4;

    border: none;
  }
  &:hover svg,
  &:hover img {
    transform: translateX(0);
  }
  &:hover span {
    display: inline-block;
    color: #256ef4;
    font-size: 16px;
    font-family: Pretendard, sans-serif;
    font-weight: 700;
    line-height: 24px;
    opacity: 1;
  }
`;
